export type AdsConsent = 'accepted' | 'rejected'
export const consentStorageKey = 'oficina.ads-consent.v1'
const consentLifetime = 180 * 24 * 60 * 60 * 1000
const consentEvent = 'oficina:ads-consent'
let temporaryChoice: { choice: AdsConsent; savedAt: number } | null = null

/** A preferência é necessária; não guarda identificadores de publicidade. */
export function getAdsConsent(): AdsConsent | null {
  try {
    const saved = temporaryChoice ?? JSON.parse(localStorage.getItem(consentStorageKey) ?? 'null')
    if (saved && (saved.choice === 'accepted' || saved.choice === 'rejected')
      && Number.isFinite(saved.savedAt) && saved.savedAt <= Date.now()
      && Date.now() - saved.savedAt < consentLifetime) return saved.choice
  } catch { /* Sem armazenamento, começa sem consentimento. */ }
  return null
}

export function saveAdsConsent(choice: AdsConsent) {
  const saved = { choice, savedAt: Date.now() }
  try {
    localStorage.setItem(consentStorageKey, JSON.stringify(saved))
    temporaryChoice = null
  } catch {
    temporaryChoice = saved
  }
  window.dispatchEvent(new Event(consentEvent))
}

export function subscribeAdsConsent(listener: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === consentStorageKey || event.key === null) listener()
  }
  window.addEventListener(consentEvent, listener)
  window.addEventListener('storage', onStorage)
  return () => {
    window.removeEventListener(consentEvent, listener)
    window.removeEventListener('storage', onStorage)
  }
}

/** Remove somente os cookies de atribuição criados pela tag do Google Ads. */
export function clearAdsCookies() {
  const names = document.cookie.split(';').map(cookie => cookie.trim().split('=')[0])
  for (const name of names.filter(name => /^_gcl_/.test(name))) {
    for (const domain of ['', window.location.hostname, '.oficina-ia.app']) {
      document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ''}`
    }
  }
}
